export class UsersModel {
    email: string;
    name: string;
    password:string;
}